import { Component, Input, OnInit, HostListener } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
// export class HeaderComponent {

//   constructor() {
//   }

// }
export class HeaderComponent implements OnInit {
  @Input() showSidebarAndHeader: boolean = false;
  showModal = false;
  currentUrl;
  isSuccess = false;
  newEstateForm!: FormGroup;
  isLoaded = false;
  errorMessage = "";
  isScrolled = false;
  isMobileMenuOpen = false;
  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private route: ActivatedRoute,

    private router: Router
  ) {
    this.newEstateForm = this.fb.group({
      email: ["", Validators.required],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      estateName: ["", Validators.required],
      estateLocation: ["", Validators.required],
      applicantCategory: ["", Validators.required],
      phoneNumber: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.urlAfterRedirects === "/product-view/community") {
          this.currentUrl = "/product-view/community";
        } else {
          this.currentUrl = this.router.url;
        }
      });
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 0;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }
  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  states = ["Abuja", "Lagos", "Kano", "Kaduna", "Oyo", "Rivers"];

  estate = {
    estateName: "",
    state: "",
    address: "",
    email: "",
    phone: "",
  };

  onSubmit() {
    if (this.newEstateForm.valid) {
      this.isLoaded = true;
      const data = this.newEstateForm.value;
      console.log(data);

      this.apiService.addEstateToWaitList(data).subscribe(
        (response) => {
          this.errorMessage = "";
          console.log("Estate added to waitlist successfully", response);
          console.log("Form submitted");
          this.isLoaded = false;
          this.isSuccess = true;
          this.newEstateForm.reset();
        },
        (error) => {
          this.errorMessage = error.error.message;
          console.log("Error adding estate to waitlist", error);
          this.isLoaded = false;
        }
      );
    } else {
      this.isLoaded = false;
      console.log("Form invalid");
    }
  }

  openModal() {
    this.currentUrl = this.router.url;
    if (this.currentUrl === "/product-view/community") {
      this.showModal = true;
    } else {
      this.showModal = false;
    }
  }
  closeModal() {
    this.showModal = false;
    this.isSuccess = false;
  }
}
